var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 11.941,
    viewBox: "0 0 22 11.941",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 11.941,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_chevron-up",
    "data-name": "Icon - chevron-up",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-up",
    d: "M1.123,146.358l.349.349a.592.592,0,0,0,.837,0l9.641-9.641,9.641,9.641a.592.592,0,0,0,.837,0l.349-.349a.592.592,0,0,0,0-.837L12.368,135.113a.592.592,0,0,0-.837,0L1.123,145.521A.592.592,0,0,0,1.123,146.358Z",
    transform: "translate(-0.95 -134.939)",
    fill: "#b2b2b2"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - chevron-up.adbe88cb4d39ab93e8089090c1b187f4.svg";